//============================================================================
// Name        : PasswordDialog.tsx
// Purpose     : Password prompt dialog component
// Created     : 2019-11-04
// Author      : Senitron Team
// Copyright   : Copyright 2019 Senitron Corporation. All rights reserved.
//============================================================================

// tslint:disable-next-line:no-unused-expression
/** @jsx jsx */ jsx;
import {css, jsx} from "@emotion/core";
import axios from "axios";
import React, {RefObject} from "react";
import { connect } from "react-redux";
import {ChangeInputEvent, IConfirmDialogProps} from "./types";

const inputStyle = css`
  text-align: left !important;
`;

interface IPasswordDialogProps {
    show: boolean;
    validatePasswordUrl: string;
    positiveCallback: () => void;
    negativeCallback: () => void;
}

interface IPasswordDialogState {
    password: string;
}

export default class PasswordDialog extends React.Component<IPasswordDialogProps, IPasswordDialogState> {
    passwordField: RefObject<HTMLInputElement>;

    constructor(props: IPasswordDialogProps) {
        super(props);
        this.passwordField = React.createRef();
        this.state = { password: "" };
    }

    componentDidUpdate(prevProps: Readonly<IPasswordDialogProps>, prevState: Readonly<IPasswordDialogState>, snapshot?: any): void {
        this.passwordField.current.focus();
    }

    getClassName = () => this.props.show ? "modal show" : "modal fade";

    onPositiveResponse = async () => {
        const pass = this.state.password;
        const resp = await axios.post(this.props.validatePasswordUrl, { pass, authenticity_token: $('meta[name="csrf-token"]').attr("content") });
        if (resp.data.message == "authorized") {
            this.props.positiveCallback();
            this.onClose();
        }
        else {
            alert("Invalid password");
        }
    }

    onClose = () => this.props.negativeCallback();
    onPasswordChange = (event: ChangeInputEvent) => this.setState({ password: event.target.value });

    onKeyPress = async (event) => {
        if (event.key == "Enter") {
            await this.onPositiveResponse();
        }
    }

    render() {
        return (
            <div className={this.getClassName()} tabIndex={-1} role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button onClick={this.onClose} type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <h1 className="modal-title">Password Request</h1>
                        </div>

                        <div className="modal-body">
                            <p>Admin password required to verify override:</p>
                            <input type="password" className="form-control" css={inputStyle} ref={this.passwordField}
                                   value={this.state.password} onChange={this.onPasswordChange}
                                   onKeyPress={this.onKeyPress}/>
                        </div>

                        <div className="modal-footer" css={{ padding: "15px" }}>
                            <button onClick={this.onPositiveResponse} className="man-btn man-green-btn">OK</button>
                            <button onClick={this.onClose} className="man-btn">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
